import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#f0f9ff',
      100: '#e0f2fe',
      200: '#bae6fd',
      300: '#7dd3fc',
      400: '#38bdf8',
      500: '#0ea5e9',
      600: '#0284c7',
      700: '#0369a1',
      800: '#075985',
      900: '#0c4a6e',
    },
    wildlife: {
      sage: '#84b59e',
      moss: '#6b9f7f',
      clay: '#c9ada7',
      sand: '#f4d5c3',
      green: '#16a34a',
    },
  },
  fonts: {
    body: "'Inter', 'Segoe UI', sans-serif",
    heading: "'Inter', 'Segoe UI', sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: 'linear-gradient(to bottom right, #f0f9ff, #dbeafe)',
        minH: '100vh',
      },
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'brand',
      },
      variants: {
        solid: {
          _hover: {
            transform: 'translateY(-2px)',
            boxShadow: 'lg',
          },
          transition: 'all 0.2s',
        },
      },
    },
    Alert: {
      variants: {
        subtle: {
          container: {
            borderRadius: 'lg',
            borderLeft: '4px solid',
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: 700,
        letterSpacing: '-0.02em',
      },
    },
  },
  semanticTokens: {
    colors: {
      'bg-primary': '#f0f9ff',
      'bg-secondary': '#dbeafe',
      'text-primary': '#0c4a6e',
      'text-secondary': '#4b5563',
    },
  },
});

export default theme;
